import { createFileRoute } from '@tanstack/react-router'
import { MagicLink } from '../components/auth/MagicLink'

export const Route = createFileRoute('/magic-link')({
  component: MagicLink,
})
